// extracted by mini-css-extract-plugin
module.exports = {"ToggleContainer":"📚4-7-03b9Gc","Checkbox":"📚4-7-01-eX4","ToggleBall":"📚4-7-0Mb9so","Toggle":"📚4-7-02uz08"};